import type { PlatformServiceDef } from '../services/platform/platformServiceService';

/** Platform add-ons that are not tenant service / sub-service modules. */
export const TENANT_NON_SERVICE_MODULE_CODES = ['wallet', 'loyalty', 'subscriptions'] as const;

/** Legacy / removed keys that must not inflate the enabled-services count. */
export const TENANT_ORPHAN_MODULE_CODES = [
  'delivery', 'food', 'grocery', 'crm', 'helpdesk', 'hrms', 'video_consultation', 'events',
  'hotel', 'flight', 'bus', 'train', 'car_rental', 'visa', 'pharmacy',
  'doctor', 'parcel', 'courier', 'rental', 'marketplace',
] as const;

/** Services & subservices shown on tenant module enable/disable UI. */
export function isTenantServiceModule(mod: Pick<PlatformServiceDef, 'code' | 'serviceType'>) {
  if (TENANT_NON_SERVICE_MODULE_CODES.includes(mod.code as (typeof TENANT_NON_SERVICE_MODULE_CODES)[number])) {
    return false;
  }
  if (TENANT_ORPHAN_MODULE_CODES.includes(mod.code as (typeof TENANT_ORPHAN_MODULE_CODES)[number])) {
    return false;
  }
  return mod.serviceType === 'business';
}

export function filterTenantServiceModules<T extends Pick<PlatformServiceDef, 'code' | 'serviceType'>>(
  services: T[],
): T[] {
  return services.filter(isTenantServiceModule);
}

/** Count enabled modules that match the service toggles UI (not wallet/orphans). */
export function countEnabledTenantServiceModules(
  tenantModules: Array<{ key: string; enabled?: boolean }> | undefined,
  serviceModuleCodes: string[] = [],
): number {
  if (serviceModuleCodes?.length) {
    const codes = new Set(serviceModuleCodes);
    return (tenantModules || []).filter((m) => m.enabled && codes.has(m.key)).length;
  }
  const excluded = new Set<string>([
    ...TENANT_NON_SERVICE_MODULE_CODES,
    ...TENANT_ORPHAN_MODULE_CODES,
  ]);
  return (tenantModules || []).filter((m) => m.enabled && !excluded.has(m.key)).length;
}
